import { Icon, IconProps } from '@chakra-ui/react';

export function SuccessIcon(props: IconProps): JSX.Element {
  return (
    <Icon
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="current"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M12.5003 0.000295119C19.4038 0.000295119 25.0002 5.59674 25.0002 12.5003C25.0002 19.4038 19.4038 25.0002 12.5003 25.0002C5.59674 25.0002 0.000295989 19.4038 0.000295989 12.5003C-0.0193476 5.61631 5.54522 0.0199387 12.4291 0.000295119C12.4528 0.000227148 12.4765 0.000227148 12.5003 0.000295119Z" />
      <path
        d="M19.4248 9.05527L10.547 17.9331L5.57538 12.997L7.59955 11.0084L10.547 13.9203L17.4007 7.06665L19.4248 9.05527Z"
        fill="white"
      />
    </Icon>
  );
}
